// extracted by mini-css-extract-plugin
module.exports = {"root":"BrandEquipmentFilter_root__Du0GM"};